import { Fandango as Fandango } from '@grins/fd-modules/splits/require-core';

export type AnalyticsPayload = {
  businessProperty: string;
  customerGUID: string;
  deviceType: string;
  loggedInStatus: boolean;
  platform: string;
  clickDetails: string;
  pageName?: string;
  pageType?: string;
  eventName?: string;
  productType?: string;
  productId?: string;
  [key: string]: unknown;
};

function triggerAnalyticsEvent(eventTriggered: string, eventData: Record<string, any> = {}) {
  const { account: { isLoggedIn }, analyticsData: { customerGUID, deviceType, pageName: contextPageName, pageType: contextPageType }, context: { device: { isMobile } } } = Fandango;
  const { pageName = contextPageName, pageType = contextPageType, eventName, productType, productId, ...extraEventData } = eventData;
  window.dataLayer = window.dataLayer || [];
  const payload: AnalyticsPayload = {
    businessProperty: 'fandango',
    customerGUID,
    deviceType,
    loggedInStatus: isLoggedIn,
    platform: isMobile ? 'fandango mobile web' : 'fandango web',
    clickDetails: eventTriggered,
    ...extraEventData
  };
  if (pageName) {
    payload.pageName = pageName;
  }
  if (pageType) {
    payload.pageType = pageType;
  }
  if (eventName) {
    payload.eventName = eventName;
  }
  if (productType) {
    payload.productType = productType;
  }
  if (productId) {
    payload.productId = productId;
  }
  window.dataLayer.push(payload);
}
export default {
  triggerAnalyticsEvent
};
